import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className=" bg-[#3699fb] text-white py-6">
            <div className="container mx-auto px-4 flex flex-col md:flex-row items-center md:justify-between">
                <div className="text-xl font-bold mb-4 md:mb-0">MyWeb</div>
                <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
                    <a href="#" className="hover:text-gray-400">Home</a>
                    <a href="#" className="hover:text-gray-400">About</a>
                    <a href="#" className="hover:text-gray-400">Contact</a>
                </div>
                <div className="flex mt-4 md:mt-0 md:ml-4">
                    <a href="#" className="text-white hover:text-gray-400 mx-2">
                        <FaFacebookF />
                    </a>
                    <a href="#" className="text-white hover:text-gray-400 mx-2">
                        <FaTwitter />
                    </a>
                    <a href="#" className="text-white hover:text-gray-400 mx-2">
                        <FaInstagram />
                    </a>
                    <a href="#" className="text-white hover:text-gray-400 mx-2">
                        <FaLinkedin />
                    </a>
                </div>
            </div>
            <div className="container mx-auto px-4 mt-4 text-center md:text-right">
                <p>ahmadraza13941394@gmail.com</p>
                <p>Phone: +92 323388294</p>
            </div>
        </footer>
    );
};

export default Footer;
